import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled, { createGlobalStyle } from 'styled-components';
import ModelViewer from './components/ModelViewer';
import cajero from './components/Productos-Quickpaymini-Medidas.png';
import qp101 from './components/QP101-Medidas.png';
import kiosko from './components/Kioskopay-medidas.png';

const menuItems = [
    {
        id: 1,
        title: "Inicio",
        sectionId: "#inicio"
    },
    {
        id: 2,
        title: "Características",
        sectionId: "#features"
    },
    {
        id: 3,
        title: "Precios",
        sectionId: "#pricing"
    },
    {
        id: 4,
        title: "Contacto",
        sectionId: "#contact"
    }
];

const productData = [
    {
        id: 1,
        title: "QuickpayMini",
        description: "Lleva tu punto de venta a donde vayas. QuickPayMini está diseñado para emprendedores, foodtrucks y pequeños comercios que necesitan una solución de cobro práctica, segura y con excelente presentación. Sin complicaciones, sin instalaciones complejas.",
        color: "#2D4E86",
        model: "/models/QPMINI.glb",
        scale: 0.3,
        image: cajero,
        imageSize: {
            width: "w-64",  
            height: "h-72"  
        },
        capacities: {
            bills: "💵 600 billetes, acepta y recicla 6 denominaciones",
            coins: "🪙 600 monedas, reciclaje de 6 denominaciones"
        }
    },
    {
        id: 2,
        title: "Quickpay101",
        description: "Agilidad, estética y funcionalidad para puntos de venta de atención rápida. Ideal para restaurantes, cadenas de tiendas o mostradores que buscan eficiencia sin perder diseño. QuickPay101 ofrece una experiencia de usuario fluida para clientes y operadores.",
        color: "#4E2D86",
        model: "/models/Quickpay101.glb",
        scale: 0.3,
        image: qp101,
        imageSize: {
            width: "w-64",  
            height: "h-96"  
        },
        capacities: {
            bills: "💵 1000 billetes, acepta y recicla 2 denominaciones",
            coins: "🪙 1200 monedas, reciclaje de 5 denominaciones"
        }
    },
    {
        id: 3,
        title: "Kioskopay",
        description: "Kioskopay es un quiosco de autoservicio diseñado para recibir pagos de forma rápida, segura y sin necesidad de personal. Ideal para espacios públicos o negocios con alto flujo de usuarios, permite pagar servicios, imprimir comprobantes y consultar información de manera sencilla e intuitiva.",
        color: "#4E2D86",
        model: "/models/KIOSKOPAY 2.glb",
        scale: 0.1,
        image: kiosko,
        imageSize: {
            width: "w-64",  
            height: "h-96"  
        },
        capacities: {
            bills: "No maneja efectivo. Acepta únicamente tarjetas",
         
        }
    },

];

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'MiFuente';
    src: url('../../../fonts/CircularStd-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const Banner = () => {
    const [currentProduct, setCurrentProduct] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getAdjustedScale = () => {
        if (isMobile) {
            return productData[currentProduct].scale * 1.5;
        }
        return productData[currentProduct].scale;
    };

    return (
        <BannerContainer id="productos" gradientStart={productData[currentProduct].color} gradientEnd="#4A90E2">
            <ContentWrapper>
                <TextSection>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={productData[currentProduct].id}
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 50 }}
                            transition={{ duration: 0.5 }}
                        >
                            <ContentContainer>
                                <TitleContainer>
                                    <Texto>{productData[currentProduct].title}</Texto>
                                </TitleContainer>
                                
                                <DescriptionContainer>
                                    <SectionTitle>Descripción del producto</SectionTitle>
                                    <DescriptionText>
                                        {productData[currentProduct].description}
                                    </DescriptionText>
                                </DescriptionContainer>

                                <CapacitiesContainer>
                                    <ImageContainer>
                                        <ProductImage
                                            src={productData[currentProduct].image}
                                            alt={productData[currentProduct].title}
                                        />
                                    </ImageContainer>
                                    
                                    <CapacityInfo>
                                        <SectionTitle>Capacidad del producto</SectionTitle>
                                        <CapacityButtons>
                                            <CapacityButton>
                                                {productData[currentProduct].capacities.bills}
                                            </CapacityButton>
                                            {productData[currentProduct].capacities.coins && (
                                                <CapacityButton>
                                                    {productData[currentProduct].capacities.coins}
                                                </CapacityButton>
                                            )}
                                        </CapacityButtons>
                                    </CapacityInfo>
                                </CapacitiesContainer>
                            </ContentContainer>
                        </motion.div>
                    </AnimatePresence>
                </TextSection>

                <ModelSection>
                <ModelViewer 
                    modelPath={productData[currentProduct].model}
                    scale={getAdjustedScale()}
                    className="model-viewer"
                />
            </ModelSection>
            </ContentWrapper>

            <ProductSelector>
                {productData.map((product, index) => (
                    <SelectorButton
                        key={product.id}
                        active={currentProduct === index}
                        onClick={() => setCurrentProduct(index)}
                        data-index={index}
                    />
                ))}
            </ProductSelector>
        </BannerContainer>
    );
};

// Nuevos estilos mejorados
const BannerContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(135deg, ${props => props.gradientStart}, ${props => props.gradientEnd});
    display: flex;
    flex-direction: column;
    padding: 40px 0;

    @media (max-width: 768px) {
        min-height: auto;
        padding: 30px 0 80px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
    gap: 40px;
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 40px;
    }

    @media (max-width: 768px) {
        padding: 0 20px;
        gap: 30px;
    }
`;

const TextSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    z-index: 2;
`;

const ContentContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const TitleContainer = styled.div`
    margin-bottom: 2rem;
    text-align: center;

    @media (max-width: 768px) {
        margin-bottom: 1.5rem;
    }
`;

const DescriptionContainer = styled.div`
    margin-bottom: 3rem;

    @media (max-width: 768px) {
        margin-bottom: 2rem;
    }
`;

const CapacitiesContainer = styled.div`
    display: flex;
    gap: 40px;
    align-items: center;

    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 30px;
    }
`;

const ImageContainer = styled.div`
    flex: 1;
    max-width: 400px;
    margin: 0 auto;
`;

const ProductImage = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
   
`;

const CapacityInfo = styled.div`
    flex: 1;
    width: 100%;
`;

const CapacityButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
`;

const CapacityButton = styled.button`
    padding: 1rem;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 2rem;
    background: rgba(0, 0, 0, 0.2);
    color: white;
    text-align: left;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

const SectionTitle = styled.h3`
    font-family: 'MiFuente';
    color: rgba(255, 255, 255, 0.8);
    text-transform: uppercase;
    margin-bottom: 1rem;
    position: relative;
    padding-bottom: 0.5rem;
    
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 50px;
        height: 2px;
        background: white;
    }
`;

const DescriptionText = styled.p`
    font-size: 1.1rem;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
`;

const ModelSection = styled.div`
    flex: 1;
    height: 70vh;
    min-height: 600px;
    position: relative;
    z-index: 1;

    @media (max-width: 1024px) {
        height: 65vh;  
        min-height: 450px;  
        order: 2;
        margin-top: 2rem;
    }

    @media (max-width: 768px) {
        height: 55vh;  
        min-height: 400px;  
    }

    @media (max-width: 480px) {
        height: 50vh;  
        min-height: 350px;
    }
`;

const ProductSelector = styled.div`
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 15px;

    @media (max-width: 1024px) {
        position: static;
        flex-direction: row;
        justify-content: center;
        transform: none;
        margin-top: 40px;
        padding-bottom: 20px;
    }
`;

const SelectorButton = styled.button`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid white;
    background: ${props => props.active 
        ? productData[props['data-index']].color 
        : 'transparent'};
    transition: all 0.3s ease;
    
    &:hover {
        transform: scale(1.3);
        border-color: ${props => productData[props['data-index']].color};
    }

    @media (max-width: 768px) {
        width: 12px;
        height: 12px;
    }
`;

const Texto = styled.h1`
    font-family: 'MiFuente';
    font-size: 3.5rem;
    color: white;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
    margin-bottom: 1.5rem;

    @media (max-width: 1024px) {
        font-size: 3rem;
    }

    @media (max-width: 768px) {
        font-size: 2.2rem;
    }
`;

export default Banner;